export const SAVE_POS_SERVICE_SETTING = "SAVE_POS_SERVICE_SETTING"
export const SAVE_POS_SERVICE_SETTING_SUCCESS = "SAVE_POS_SERVICE_SETTING_SUCCESS"


export const DELETE_POS_SERVICE_SETTING_LIST_ID = "DELETE_POS_SERVICE_SETTING_LIST_ID"
export const DELETE_POS_SERVICE_SETTING_LIST_ID_SUCCESS = "DELETE_POS_SERVICE_SETTING_LIST_ID_SUCCESS"

export const GET_POS_SERVICE_SETTING_LIST = "GET_POS_SERVICE_SETTING_LIST"
export const GET_POS_SERVICE_SETTING_LIST_SUCCESS = "GET_POS_SERVICE_SETTING_LIST_SUCCESS"


export const EDIT_POS_SERVICE_SETTING_ID = "EDIT_POS_SERVICE_SETTING_ID"
export const EDIT_POS_SERVICE_SETTING_ID_SUCCESS = "EDIT_POS_SERVICE_SETTING_ID_SUCCESS"


export const UPDATE_POS_SERVICE_SETTING_ID = "UPDATE_POS_SERVICE_SETTING_ID"
export const UPDATE_POS_SERVICE_SETTING_ID_SUCCESS = "UPDATE_POS_SERVICE_SETTING_ID_SUCCESS"

export const POS_SERVICE_SETTING_API_ERROR_ACTION = "POS_SERVICE_SETTING_API_ERROR_ACTION"